import React, { useRef, useState } from "react";
import { CSVLink } from "react-csv";
import {
  filterIfNoStockIsActive,
  getExcelDataFromProductos,
} from "utils/randomFunctions";
import { useSearchParams } from "react-router-dom";
import { productosAPI } from "API/productos";
import { errorHandler } from "API/errorHandler";
import { BtnPagar, Spinner } from "components/styles/smallComponents";
import styled from "styled-components";
import { useAppDispatch } from "context/store";

const ExcelButton = styled(BtnPagar)`
  transition: 0.3s;
`;
const CSV = ({ totalProductos }: { totalProductos: number }) => {
  let [searchParams] = useSearchParams();
  const [prodExcel, setProdExcel] = useState<IProducto[]>([]);
  const csvShittyBtn = useRef<CSVLink>(null);
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  async function fetchAndExportExcel() {
    setLoading(true);
    try {
      const { data } = await productosAPI.getFullProdForExcel(searchParams);
      const maybeProdsWithoutStock = filterIfNoStockIsActive(
        data.productos,
        searchParams
      );
      setProdExcel(maybeProdsWithoutStock);
      csvShittyBtn?.current.link.click();
    } catch (error) {
      errorHandler(error, dispatch, "GET EXCEL DATA");
    } finally {
      setLoading(false);
    }
  }

  const text = `Exportar a Excel ${totalProductos} productos`;
  return (
    <div>
      <ExcelButton text={text} onClick={fetchAndExportExcel} disabled={loading}>
        {loading ? <Spinner /> : text}
      </ExcelButton>
      <CSVLink
        ref={csvShittyBtn}
        data={getExcelDataFromProductos(prodExcel)}
        style={{ display: "none" }}
      />
    </div>
  );
};

export default CSV;
